/* eslint-disable local-rules/no-hardcoded-id-in-svg */
import React from 'react'
import { G, Path, Defs, LinearGradient, Stop, RadialGradient } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'

import { AccessibleIcon } from '../../types'

function FirstArtLessonBookingUnlockedDetailedSvg({
  size,
  accessibilityLabel,
  testID,
}: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 260 260"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M238.706 215.558C238.706 215.558 139.545 254.796 130.655 254.796C121.764 254.796 22.3743 215.956 22.3743 215.956C18.0326 215.962 17.8004 48.9266 22.1453 48.9203C22.1453 48.9203 124.573 5 130.658 5C136.743 5 238.48 48.5227 238.48 48.5227C240.474 48.5227 240.703 215.555 238.709 215.558H238.706Z"
          fill="url(#paint0_linear_8631_22739)"
        />
        <Path
          d="M130.658 254.8C139.548 254.8 238.709 215.561 238.709 215.561C240.703 215.561 240.474 48.5226 238.48 48.5258C238.48 48.5258 136.743 5.00317 130.658 5.00317V254.803V254.8Z"
          fill="url(#paint1_linear_8631_22739)"
        />
        <Path
          d="M234.609 53.2567C234.609 53.2567 136.52 11 130.655 11C124.79 11 26.0327 53.6416 26.0327 53.6416C21.8436 53.6479 22.0663 215.817 26.2554 215.811C26.2554 215.811 122.083 253.519 130.655 253.519C139.227 253.519 234.832 215.423 234.832 215.423C236.753 215.423 236.534 53.2503 234.609 53.2535V53.2567ZM226.114 208.6C226.114 208.6 138.521 243.503 130.668 243.503C122.814 243.503 35.0184 208.953 35.0184 208.953C31.1824 208.959 30.9788 60.3785 34.8149 60.3753C34.8149 60.3753 125.295 21.3089 130.668 21.3089C136.04 21.3089 225.91 60.0222 225.91 60.0222C227.672 60.0222 227.876 208.6 226.114 208.6Z"
          fill="#BCB6C3"
        />
        <Path
          d="M238.477 48.5227C238.477 48.5227 136.739 5 130.658 5C124.576 5 22.1453 48.9203 22.1453 48.9203C17.8035 48.9266 18.0326 215.962 22.3743 215.956C22.3743 215.956 121.764 254.796 130.655 254.796C139.545 254.796 238.706 215.558 238.706 215.558C240.7 215.558 240.471 48.5195 238.477 48.5227ZM229.663 208.529C229.663 208.529 138.813 244.481 130.667 244.481C122.521 244.481 31.4618 208.895 31.4618 208.895C27.4827 208.901 27.2727 55.8639 31.2519 55.8575C31.2519 55.8575 125.095 15.6175 130.667 15.6175C136.24 15.6175 229.453 55.4918 229.453 55.4918C231.279 55.4918 231.492 208.526 229.663 208.529Z"
          fill="url(#paint2_linear_8631_22739)"
        />
        <Path
          d="M47.7219 70.311V198.605C47.7219 198.678 47.7665 198.745 47.8301 198.773L106.143 224.29C106.729 224.547 107.244 223.809 106.799 223.348L67.7259 182.726C67.7004 182.701 67.6845 182.666 67.6782 182.631L48.0877 70.2792C48.0495 70.0597 47.7251 70.0852 47.7251 70.311H47.7219Z"
          fill="#E3DEED"
        />
        <Path
          d="M209.713 70.311V198.605C209.713 198.678 209.668 198.745 209.605 198.773L151.291 224.29C150.706 224.547 150.191 223.809 150.636 223.348L189.709 182.726C189.734 182.701 189.75 182.666 189.757 182.631L209.347 70.2792C209.385 70.0597 209.71 70.0852 209.71 70.311H209.713Z"
          fill="#EFEEF0"
        />
        <Path
          d="M101.787 218.356L98.1876 217.525C97.1744 219.446 96.1717 221.395 95.2429 223.343C101.734 223.004 99.2325 222.78 101.787 218.356Z"
          fill="#7F8AA5"
        />
        <Path
          d="M220.566 182.06C219.521 180.147 213.42 180.871 211.077 180.809V92.9504V90.7338C200.333 91.279 187.161 90.4121 176.058 90.4568C171.372 90.4746 166.675 90.4389 161.978 90.4568C138.832 90.5193 114.473 91.0288 90.4828 91.0109C114.462 91.0288 138.832 90.5193 161.968 90.4568C166.654 90.4478 171.361 90.4746 176.047 90.4568C187.15 90.4121 200.322 91.279 211.067 90.7338C211.098 90.7338 210.961 90.1976 211.225 90.1797C215.943 89.9026 221.874 91.2075 220.555 85.1924C220.555 85.1924 220.534 85.2014 220.523 85.2103C220.154 83.8786 218.761 82.8865 217.072 82.8865H137.102C137.028 81.9927 136.827 80.8397 136.595 80.7593C135.93 80.5269 122.779 80.4107 122.199 80.7593C122.04 80.8487 121.977 81.9391 121.998 82.8865H41.9537C39.9378 82.8865 38.3019 84.2718 38.3019 85.9789V87.6324H38.6713C39.79 90.7785 44.1596 90.0009 48.0752 90.1797V93.5045C92.3615 93.5671 136.669 93.4956 180.955 93.2275C188.596 93.1828 196.227 93.2275 203.869 93.2275C196.238 93.2275 188.607 93.1828 180.955 93.2275C136.669 93.4867 92.3615 93.5671 48.0752 93.5045C48.1175 120.416 48.0752 178.753 48.0752 178.869C48.1175 179.325 47.9064 180.889 48.2336 181.086L107.634 181.363C136.542 181.273 165.472 180.871 194.37 180.809C198.285 180.809 202.233 180.746 206.159 180.764C202.233 180.746 198.285 180.8 194.37 180.809C165.472 180.871 136.542 181.273 107.644 181.363C84.794 181.434 61.9332 181.309 39.0724 181.363C37.7425 181.801 38.2386 184.25 38.5763 185.242C62.9886 184.822 87.4537 184.822 111.887 184.687C87.4431 184.83 62.9886 184.822 38.5763 185.242C39.0196 186.529 39.3257 186.904 41.0355 187.458C56.6876 187.708 78.9627 187.744 104.715 187.7L102.256 197.116H102.267C101.739 198.224 101.264 199.341 100.747 200.45L106.964 201.147L100.747 200.459C97.7179 207.064 94.7627 213.758 91.913 220.417C90.942 222.678 89.7599 224.885 88.9683 227.209C89.401 228.166 92.4724 227.388 93.2217 227.343C94.1505 225.395 95.1532 223.446 96.1664 221.525L99.7654 222.356C100.135 221.721 100.694 221.087 101.074 220.417C104.631 214.124 107.671 207.6 111.217 201.29C111.987 199.922 112.589 198.448 113.507 197.134H113.497L113.845 197.125C113.729 197.125 113.623 197.134 113.507 197.143C112.589 198.456 111.987 199.931 111.217 201.299H148.292C149.484 201.638 157.442 218.03 158.762 220.425C159.036 220.917 159.532 221.444 159.743 221.811C160.303 222.821 161.559 226.646 162.361 227.218C163.173 227.79 165.179 227.79 166.287 227.915C167.923 228.103 169.527 228.46 171.195 228.049C170.361 225.431 168.989 222.964 167.923 220.425C165.147 213.812 162.625 207.046 159.743 200.467C159.173 199.171 158.403 197.867 157.78 196.588C157.77 196.588 157.759 196.588 157.749 196.588L155.469 187.583C185.517 187.476 208.629 187.36 218.413 187.467C220.819 186.591 221.589 183.99 220.545 182.06H220.566Z"
          fill="#7F8AA5"
        />
        <Path
          d="M163.471 219.034C164.478 221.873 165.785 224.632 166.571 227.56C164.986 228.019 163.471 227.614 161.919 227.406C161.446 224.511 159.713 221.691 158.508 219.034C155.246 211.831 152.044 204.595 148.584 197.481L155.717 196.706C158.447 204.063 160.842 211.63 163.471 219.034Z"
          fill="#CCDAFC"
        />
        <Path
          d="M100.21 220.273C99.2506 222.424 98.2986 224.601 97.4191 226.785C96.7063 226.828 93.7948 227.698 93.3889 226.63C94.1403 224.033 95.2639 221.561 96.1796 219.034C98.8809 211.582 101.681 204.094 104.552 196.706L110.445 197.481C106.91 205.02 103.6 212.672 100.212 220.273H100.21Z"
          fill="#CCDAFC"
        />
        <Path
          d="M116.335 192.673L116.645 192.982C115.77 194.454 115.207 196.099 114.475 197.633C111.107 204.694 108.234 211.993 104.861 219.031C104.503 219.78 103.969 220.488 103.621 221.201L100.21 220.271C103.597 212.669 106.91 205.017 110.442 197.479L104.549 196.703C105.071 195.357 105.549 194.009 106.1 192.673H116.333H116.335Z"
          fill="#91ADF9"
        />
        <Path
          d="M155.719 196.706L148.587 197.481C152.047 204.595 155.248 211.831 158.51 219.034C157.493 219.28 155.939 219.58 155.719 220.585C155.524 220.172 155.048 219.589 154.789 219.034C153.54 216.354 145.999 198.015 144.866 197.636L143.315 192.673C146.801 192.673 150.406 192.929 153.859 192.364C154.446 193.799 155.181 195.254 155.719 196.706Z"
          fill="#91ADF9"
        />
        <Path
          d="M158.51 219.034C159.713 221.694 161.448 224.511 161.922 227.406C160.871 227.266 158.967 227.268 158.201 226.63C157.435 225.992 156.251 221.713 155.719 220.582C155.939 219.577 157.493 219.278 158.51 219.031V219.034Z"
          fill="#6378B1"
        />
        <Path
          d="M103.622 221.203C101.198 226.159 103.566 226.405 97.4192 226.785C98.2987 224.601 99.2507 222.424 100.21 220.273L103.622 221.203Z"
          fill="#6378B1"
        />
        <Path
          d="M143.314 192.673L144.866 197.636H114.475C115.207 196.102 115.77 194.456 116.645 192.985C125.507 192.417 134.435 192.675 143.314 192.675V192.673Z"
          fill="#003365"
        />
        <Path
          d="M154.057 192.968H105.975L108.391 186.686H151.641L154.057 192.968Z"
          fill="#6378B1"
        />
        <Path
          d="M122.973 67.2464C123.528 66.8526 135.984 66.9903 136.617 67.2464C136.955 67.3841 137.226 70.3995 137.083 70.7475C136.817 71.3998 123.55 71.6221 122.973 71.2138C122.719 71.0326 122.719 67.4276 122.973 67.2464Z"
          fill="#7190E2"
        />
        <Path
          d="M207.165 80.8907V177.333H201.892V83.836L200.341 81.2C202.533 81.2 204.92 80.5597 207.165 80.8907Z"
          fill="#AC70DC"
        />
        <Path
          d="M173.986 78.1C169.547 78.1217 165.092 78.0855 160.651 78.1C125.568 78.2087 87.5154 79.6149 52.7344 77.7907C52.7344 79.0278 52.7344 80.2745 52.7344 81.5116C94.6987 81.5817 136.677 81.4971 178.637 81.2024C185.881 81.1516 193.11 81.2024 200.344 81.2024C202.535 81.2024 204.923 80.5621 207.167 80.8931V78.4117C196.983 79.023 184.508 78.0517 173.986 78.1024V78.1Z"
          fill="#765690"
        />
        <Path
          d="M207.165 78.4092C196.981 79.0205 184.506 78.0492 173.983 78.0999C169.545 78.1217 165.089 78.0854 160.648 78.0999C122.248 76.8773 83.543 78.0105 45.29 76.7034L44.9807 74.6883C67.7146 74.6883 90.4727 74.2461 113.204 74.0673C121.364 74.0045 129.542 74.1229 137.702 74.0673C159.498 73.9223 191.315 76.1791 211.816 73.4464C213.437 73.2313 214.735 73.1854 216.158 72.2068C217.405 78.9359 211.794 77.4741 207.319 77.7882C207.063 77.8052 207.196 78.4068 207.165 78.4092Z"
          fill="#003365"
        />
        <Path
          d="M44.9807 74.6883L45.29 76.7034C83.543 78.0105 122.248 76.8749 160.648 78.0999C125.565 78.2087 87.5128 79.6149 52.7318 77.7907C48.9239 77.5901 44.6642 78.5252 43.7388 74.6907H44.9783L44.9807 74.6883Z"
          fill="#645E5F"
        />
        <Path
          d="M191.351 179.193L214.764 179.814C216.061 180.239 216.291 183.755 215.385 184.156C181.36 182.631 147.26 183.308 113.207 183.535C90.0498 183.69 66.8762 183.685 43.7436 184.156C43.4175 183.04 42.9463 180.302 44.21 179.814C65.8638 179.756 87.5273 179.891 109.176 179.814C136.566 179.715 163.975 179.261 191.353 179.193H191.351Z"
          fill="url(#paint3_linear_8631_22739)"
        />
        <Path
          d="M216.158 180.59C215.167 178.451 209.393 179.258 207.165 179.193C206.858 179.184 206.541 179.2 206.235 179.193C201.291 179.077 196.297 179.181 191.351 179.193L214.764 179.814C216.061 180.239 216.291 183.755 215.385 184.156C181.36 182.631 147.26 183.308 113.207 183.535C90.0499 183.69 66.8762 183.685 43.7437 184.156C44.1641 185.596 44.454 186.012 46.0704 186.637C87.4911 187.411 192.595 186.357 214.148 186.637C216.433 185.657 217.161 182.743 216.163 180.59H216.158Z"
          fill="#003365"
        />
        <Path
          d="M201.895 177.333C194.975 177.333 188.038 177.342 181.118 177.333C179.468 177.333 177.806 177.34 176.155 177.333C175.332 177.328 174.498 177.338 173.674 177.333C133.372 177.115 93.0435 176.857 52.7342 177.023C52.7753 177.533 52.5699 179.278 52.8889 179.505L109.171 179.814C136.561 179.715 163.971 179.261 191.348 179.193C196.297 179.181 201.289 179.077 206.235 179.193C206.541 179.2 206.858 179.184 207.165 179.193V177.333H201.893H201.895Z"
          fill="url(#paint4_linear_8631_22739)"
        />
        <Path
          d="M200.344 81.2023L201.895 83.8384V177.335C194.975 177.335 188.038 177.345 181.118 177.335C179.468 177.335 177.806 177.342 176.156 177.335C175.332 177.33 174.498 177.34 173.674 177.335C133.372 177.118 52.7344 177.026 52.7344 177.026C52.7344 177.026 52.7755 111.651 52.7344 81.514C94.6987 81.5841 136.678 81.4995 178.637 81.2047C185.881 81.154 193.11 81.2047 200.344 81.2047V81.2023Z"
          fill="url(#paint5_linear_8631_22739)"
        />
        <Path
          d="M58.1609 86.472L60.4877 86.9384L59.7121 174.233L58.6272 173.766L58.1609 86.472Z"
          fill="#F7F1E1"
        />
        <Path
          d="M106.383 153.144C105.98 152.944 104.866 153.318 104.368 152.214L66.069 152.523C65.465 151.542 63.7495 150.709 65.2934 149.733H104.366C104.875 151.881 108.768 151.17 106.381 153.144H106.383Z"
          fill="#FCFCFB"
        />
        <Path
          d="M106.383 159.658L104.368 158.728H66.069C65.0929 158.199 64.4429 157.363 64.9842 156.247C75.6951 156.807 86.5921 155.556 97.2354 155.937C100.751 156.063 102.358 155.882 104.989 157.489C105.383 157.73 106.864 157.96 107.004 158.264C107.299 158.9 106.446 159.238 106.383 159.661V159.658Z"
          fill="#FCFCFB"
        />
        <Path
          d="M69.79 162.758C77.8432 162.439 96.3971 161.567 103.592 162.758C105.989 163.155 104.704 163.546 105.298 163.998C105.431 164.099 106.791 164.145 107.004 164.773C107.304 165.658 106.429 165.435 106.383 165.858L104.677 165.237H66.0691L64.8296 164.152C64.3947 161.988 68.2243 162.819 69.7924 162.756L69.79 162.758Z"
          fill="#FCFCFB"
        />
        <Path
          d="M106.383 159.658C106.378 159.697 107.069 159.96 107.004 160.125C106.308 161.823 102.583 160.879 101.111 160.9C91.166 161.04 79.938 161.441 70.1017 160.9C68.3089 160.801 64.803 161.637 66.0715 158.731H104.37L106.386 159.661L106.383 159.658Z"
          fill="#86AAA6"
        />
        <Path
          d="M98.6297 146.633L66.0691 146.012C65.122 145.917 64.3802 143.931 65.2935 143.53H96.6146C97.6076 145.917 99.154 143.699 98.6297 146.63V146.633Z"
          fill="#FCFCFB"
        />
        <Path
          d="M106.383 165.861C106.369 165.986 108.031 166.039 105.607 167.412H67.7748C66.6779 167.025 65.3176 166.762 66.069 165.242H104.677L106.383 165.863V165.861Z"
          fill="#86AAA6"
        />
        <Path
          d="M106.383 153.144C107.821 153.862 106.047 154.229 105.298 154.696L66.5355 154.386C65.6754 154.029 66.1199 152.608 66.0692 152.526L104.368 152.216C104.866 153.321 105.98 152.946 106.383 153.147V153.144Z"
          fill="#86AAA6"
        />
        <Path
          d="M98.6296 146.633C98.5281 147.205 98.6997 147.843 97.233 148.184L66.533 147.875L66.0667 146.014L98.6272 146.635L98.6296 146.633Z"
          fill="#86AAA6"
        />
        <Path
          d="M101.111 160.898L99.0957 162.137L103.592 162.758C96.3968 161.567 77.8454 162.439 69.7898 162.758L70.0991 160.898C79.9354 161.439 91.1658 161.038 101.108 160.898H101.111Z"
          fill="#BFDDCF"
        />
        <Path
          d="M154.448 158.416C176.452 173.834 203.973 149.433 189.49 126.165C209.431 150.235 177.032 179.391 154.448 158.416Z"
          fill="#6C7BBC"
        />
        <Path
          d="M149.176 152.835C148.896 154.524 147.871 152.236 147.78 152.214C145.409 151.67 141.082 152.618 138.477 152.214C137.789 152.521 138.211 156.433 138.011 157.332C135.948 166.61 122.627 169.072 119.716 159.347C125.104 168.98 140.978 161.739 136.617 150.663C138.716 151.134 146.402 150.037 147.78 150.663C148.538 151.008 148.729 152.33 149.176 152.833V152.835Z"
          fill="#6894B4"
        />
        <Path
          d="M189.49 126.165C203.973 149.431 176.452 173.834 154.448 158.416C152.44 156.551 150.969 154.867 149.176 152.835C148.732 152.33 148.541 151.008 147.78 150.665C146.4 150.04 138.714 151.136 136.617 150.665C140.978 161.741 125.104 168.98 119.716 159.349C115.647 152.076 122.516 143.989 130.414 145.705C132.918 146.249 135.022 149.233 135.687 149.426C136.257 149.593 146.975 149.742 147.316 149.271C137.651 121.845 170.223 102.912 189.49 126.168V126.165Z"
          fill="#FBE9F0"
        />
        <Path
          d="M178.482 122.135C182.756 124.179 185.607 128.086 187.63 132.213L173.519 135.779L178.482 122.135Z"
          fill="#4665B6"
        />
        <Path
          d="M128.709 146.633C127.897 148.865 126.73 150.668 126.539 153.144C126.457 154.219 126.442 153.272 126.848 154.074C127.766 155.889 134.138 157.542 133.981 158.88C131.224 162.5 126.454 163.681 122.661 160.895C116.244 156.179 121.016 145.925 128.709 146.63V146.633Z"
          fill="#ECD2D1"
        />
        <Path
          d="M133.671 149.735C135.126 151.972 135.346 154.932 134.447 157.489L126.851 154.077C126.445 153.275 126.457 154.222 126.541 153.147L133.674 149.735H133.671Z"
          fill="#7F6A71"
        />
        <Path
          d="M133.672 149.735L126.539 153.147C126.73 150.67 127.899 148.868 128.709 146.635C130.461 146.797 132.725 148.28 133.672 149.735Z"
          fill="#D9B5B3"
        />
        <Path
          d="M164.992 110.972C177.069 115.703 188.536 103.443 181.427 92.0558C192.001 103.533 178.373 119.255 164.992 110.972Z"
          fill="#6C7BBC"
        />
        <Path
          d="M181.427 92.0559C188.536 103.443 177.069 115.703 164.993 110.972C146.381 99.4518 167.095 76.5005 181.427 92.0559Z"
          fill="#FBE9F0"
        />
        <Path
          d="M174.498 99.2198L181.009 102.011C179.299 110.511 166.954 112.871 162.093 105.577C157.36 98.4757 162.741 89.4657 170.931 88.9873L172.328 99.6862C172.792 100.467 173.966 99.4591 174.498 99.2198Z"
          fill="#809EF8"
        />
        <Path
          d="M172.482 89.9176C174.162 89.2242 180.151 92.8968 179.77 94.4141C179.608 95.0544 174.147 97.4223 173.413 98.2897L172.482 89.9176Z"
          fill="#645E5F"
        />
        <Path
          d="M179.994 104.794L172.745 100.082C173.659 99.6741 180.144 95.6415 180.545 95.8082C181.587 97.7556 181.437 99.8964 181.012 102.011L180.598 103.586L179.994 104.794Z"
          fill="#6B585B"
        />
        <Path
          d="M71.3413 128.028C82.8351 134.31 96.0154 121.466 87.7762 110.351C99.4826 121.881 83.3159 136.509 71.3413 128.028Z"
          fill="#86AAA6"
        />
        <Path
          d="M87.7761 110.351C96.0153 121.463 82.835 134.308 71.3412 128.028C56.153 117.271 73.6583 96.4461 87.7761 110.351Z"
          fill="#FBE9F0"
        />
        <Path
          d="M74.9075 107.561C90.1294 104.68 91.8981 126.042 79.2493 127.716C64.9576 129.608 63.8172 109.658 74.9075 107.561Z"
          fill="#ECD2D1"
        />
        <Path
          d="M102.351 129.889C122.301 145.04 150.57 122.693 137.083 100.428C153.049 120.753 128.581 143.265 107.159 133.609C105.861 133.025 102.841 131.225 102.353 129.889H102.351Z"
          fill="#6894B4"
        />
        <Path
          d="M137.083 100.428C150.573 122.691 122.301 145.038 102.351 129.888C75.7581 109.692 114.236 71.3491 137.083 100.428Z"
          fill="#FBE9F0"
        />
        <Path
          d="M117.546 99.4977C120.554 99.7152 125.097 102.339 126.848 104.77C127.114 105.137 128.624 108.136 128.709 108.491C129.192 110.53 129.18 113.26 128.709 115.314C128.341 116.911 126.773 119.419 125.609 120.586C122.166 124.029 117.167 124.909 112.586 123.686C109.952 122.985 106.958 121.05 105.453 118.723C102.926 114.814 102.858 108.979 105.453 105.079C107.799 101.554 113.385 99.1957 117.546 99.4977Z"
          fill="#FBE9F0"
        />
        <Path
          d="M188.709 134.96C188.124 134.407 181.27 136.4 180.025 136.666C178.421 137.007 176.937 137.509 175.374 137.905C173.796 138.307 171.827 138.386 170.102 138.836L176.304 119.455C160.66 113.932 146.112 126.868 149.016 143.178C149.874 148.003 153.389 152.866 157.388 155.582C162.387 158.977 166.997 159.782 172.893 158.682C173.888 158.496 174.69 158.402 175.683 158.061C177.839 157.322 180.11 155.771 181.886 154.34C182.939 153.492 183.836 152.61 184.677 151.55C185.194 150.897 185.488 150.387 185.916 149.689C188.825 144.941 189.714 140.58 188.707 134.96H188.709Z"
          fill="url(#paint6_radial_8631_22739)"
        />
        <Path
          d="M132.89 100.694C132.311 99.9133 131.694 99.4856 131.03 98.8333C127.691 95.5473 123.736 93.3437 118.937 92.9402C111.925 92.3506 105.803 94.7451 101.26 100.073C94.8742 107.565 94.9491 117.513 101.569 124.882C104.16 127.765 106.211 129.239 109.942 130.464C122.378 134.544 136.266 127.069 136.921 113.408C137.003 111.712 136.607 110.375 136.3 108.757C135.688 105.519 134.886 103.381 132.888 100.694H132.89ZM128.86 114.959C128.493 116.556 126.925 119.064 125.76 120.231C122.317 123.674 117.318 124.554 112.737 123.331C110.103 122.63 107.11 120.695 105.604 118.368C103.077 114.459 103.009 108.624 105.604 104.724C107.951 101.199 113.537 98.8405 117.697 99.1425C120.706 99.36 125.248 101.984 127 104.415C127.266 104.782 128.776 107.78 128.86 108.136C129.344 110.175 129.331 112.905 128.86 114.959Z"
          fill="url(#paint7_radial_8631_22739)"
        />
        <Path
          d="M115.902 119.803C120.266 119.803 123.803 116.266 123.803 111.902C123.803 107.538 120.266 104 115.902 104C111.538 104 108 107.538 108 111.902C108 116.266 111.538 119.803 115.902 119.803Z"
          fill="#765690"
        />
        <Path
          d="M115.902 104C111.537 104 108 107.537 108 111.902C108 113.409 108.422 114.816 109.153 116.014C110.512 117.118 112.244 117.78 114.132 117.78C118.496 117.78 122.033 114.243 122.033 109.879C122.033 108.372 121.611 106.965 120.88 105.766C119.521 104.662 117.789 104 115.902 104Z"
          fill="url(#paint8_radial_8631_22739)"
        />
        <Path
          d="M112.804 111.333C114.48 111.333 115.838 109.974 115.838 108.299C115.838 106.623 114.48 105.264 112.804 105.264C111.128 105.264 109.77 106.623 109.77 108.299C109.77 109.974 111.128 111.333 112.804 111.333Z"
          fill="#F5F0FF"
        />
        <Path
          d="M46.9331 69.6288H212.865C214.72 69.6288 216.226 71.1341 216.226 72.9897V74.9444H43.4683V73.0936C43.4683 71.1824 45.0219 69.6288 46.9331 69.6288Z"
          fill="url(#paint9_linear_8631_22739)"
        />
        <Path
          d="M66.3318 184.042C65.7645 183.653 65.789 184.806 65.6663 185.042C62.6762 190.762 61.4311 194.034 55 196.929C61.3575 199.61 62.7989 203.949 65.6663 209.485C65.7675 209.684 65.7737 210.656 66.3318 210.264C68.0554 204.053 71.5147 199.882 77.219 196.932C71.5024 194.172 68.3743 189.992 66.3318 184.046V184.042Z"
          fill="#7F8AA5"
        />
        <Path
          d="M66.9668 207.522C67.1109 205.706 67.5771 202.808 67.1876 201.078C67.5372 200.931 67.3256 200.631 67.6323 200.189C69.4386 197.595 70.1931 195.935 73.4101 194.746C70.4445 194.31 69.365 191.746 67.4115 189.967C67.4053 189.82 67.4176 189.67 67.4115 189.523C67.3133 187.391 67.7856 185.036 66.9668 183.079C67.0895 182.843 67.0649 181.69 67.6323 182.08C69.6778 188.026 72.8029 192.206 78.5194 194.966C72.8121 197.917 69.3558 202.091 67.6323 208.298C67.0711 208.693 67.068 207.718 66.9668 207.519V207.522Z"
          fill="#A6C2FF"
        />
        <Path
          d="M67.4082 189.523C66.0098 191.765 64.1605 193.488 61.8543 194.746C63.8017 195.862 66.6906 198.861 67.1874 201.079C67.5738 202.808 67.1108 205.706 66.9666 207.522C64.1022 201.986 62.6578 197.65 56.3003 194.966C62.7314 192.068 63.9765 188.796 66.9666 183.079C67.7855 185.036 67.3132 187.391 67.4113 189.523H67.4082Z"
          fill="#85ABFF"
        />
        <Path
          d="M67.4086 189.968C67.5374 193.369 67.9545 196.736 67.6294 200.189C67.3227 200.631 67.5343 200.931 67.1847 201.079C66.6879 198.861 63.799 195.862 61.8516 194.746C64.1578 193.491 66.0101 191.765 67.4055 189.523C67.4117 189.67 67.3994 189.82 67.4055 189.968H67.4086Z"
          fill="#5E89E7"
        />
        <Path
          d="M67.6322 200.189C67.9542 196.739 67.5371 193.369 67.4114 189.968C69.368 191.743 70.4444 194.307 73.41 194.746C70.193 195.936 69.4385 197.598 67.6322 200.189Z"
          fill="#D8E4FF"
        />
        <Path
          d="M139.888 46.3096C141.192 49.5113 142.593 51.3637 146 52.4217C142.326 53.5656 140.959 55.7461 139.667 59.1993C139.299 55.5284 136.932 53.86 134 52.2009C137.515 51.5385 138.803 49.4592 139.888 46.3126V46.3096Z"
          fill="#7F8AA5"
        />
        <Path
          d="M140.768 45C142.072 48.2017 143.473 50.0541 146.881 51.1121C143.206 52.2561 141.839 54.4365 140.548 57.8898C140.18 54.2188 137.812 52.5505 134.88 50.8913C138.395 50.2289 139.683 48.1496 140.768 45.0031V45Z"
          fill="#85ABFF"
        />
        <Path
          d="M184.888 194.31C186.192 197.511 187.593 199.364 191 200.422C187.326 201.566 185.959 203.746 184.667 207.199C184.299 203.528 181.932 201.86 179 200.201C182.515 199.538 183.803 197.459 184.888 194.313V194.31Z"
          fill="#7F8AA5"
        />
        <Path
          d="M185.768 193C187.072 196.202 188.473 198.054 191.881 199.112C188.206 200.256 186.839 202.437 185.548 205.89C185.18 202.219 182.812 200.55 179.88 198.891C183.395 198.229 184.683 196.15 185.768 193.003V193Z"
          fill="#C58CF0"
        />
        <Path
          d="M58.8882 61.3096C60.1916 64.5113 61.5932 66.3637 65.0004 67.4217C61.3263 68.5656 59.9586 70.7461 58.6674 74.1993C58.2994 70.5284 55.9319 68.86 53 67.2009C56.5146 66.5385 57.8026 64.4592 58.8882 61.3126V61.3096Z"
          fill="#7F8AA5"
        />
        <Path
          d="M59.7684 60C61.0718 63.2017 62.4733 65.0541 65.8805 66.1121C62.2065 67.2561 60.8387 69.4365 59.5476 72.8898C59.1795 69.2188 56.812 67.5505 53.8801 65.8913C57.3947 65.2289 58.6827 63.1496 59.7684 60.0031V60Z"
          fill="#C58CF0"
        />
        <Path
          d="M184.833 47.1328C184.24 46.7261 184.266 47.9302 184.138 48.1768C181.016 54.1493 179.715 57.5663 173 60.5894C179.639 63.3883 181.144 67.9197 184.138 73.7001C184.244 73.9082 184.25 74.9234 184.833 74.5135C186.633 68.0286 190.245 63.6733 196.202 60.5926C190.232 57.7104 186.966 53.3455 184.833 47.136V47.1328Z"
          fill="#7F8AA5"
        />
        <Path
          d="M185.493 71.6504C185.643 69.7546 186.13 66.7283 185.723 64.9222C186.088 64.7684 185.867 64.4546 186.188 63.9935C188.074 61.2842 188.862 59.5517 192.221 58.3092C189.124 57.8544 187.997 55.1772 185.957 53.3198C185.951 53.1661 185.963 53.0092 185.957 52.8554C185.855 50.6298 186.348 48.1703 185.493 46.1272C185.621 45.8806 185.595 44.6765 186.188 45.0832C188.324 51.2927 191.587 55.6576 197.556 58.5397C191.596 61.6205 187.987 65.979 186.188 72.4606C185.602 72.8738 185.598 71.8554 185.493 71.6472V71.6504Z"
          fill="#E5C3FF"
        />
        <Path
          d="M185.957 52.8554C184.497 55.1963 182.566 56.9961 180.157 58.3091C182.191 59.4748 185.208 62.6067 185.726 64.9221C186.13 66.7282 185.646 69.7545 185.496 71.6504C182.505 65.87 180.997 61.3418 174.358 58.5396C181.073 55.5134 182.374 52.0964 185.496 46.1271C186.351 48.1702 185.858 50.6297 185.96 52.8554H185.957Z"
          fill="#C58CF0"
        />
        <Path
          d="M185.957 53.3198C186.091 56.8712 186.527 60.3875 186.187 63.9934C185.867 64.4546 186.088 64.7684 185.723 64.9221C185.204 62.6068 182.188 59.4748 180.154 58.3091C182.562 56.9993 184.497 55.1964 185.954 52.8554C185.96 53.0091 185.947 53.166 185.954 53.3198H185.957Z"
          fill="#D7A2FF"
        />
        <Path
          d="M186.188 63.9935C186.524 60.3908 186.089 56.8713 185.957 53.3198C188 55.174 189.124 57.8512 192.221 58.3092C188.862 59.5517 188.074 61.2874 186.188 63.9935Z"
          fill="#F3E4FF"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_8631_22739"
            x1="129.548"
            y1="5"
            x2="129.548"
            y2="254.796"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEEBF3" />
            <Stop offset="1" stopColor="#B5B2BC" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_8631_22739"
            x1="185.376"
            y1="5.00317"
            x2="185.376"
            y2="254.803"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#FBF6F6" />
            <Stop offset="1" stopColor="#C4C4C4" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_8631_22739"
            x1="129.547"
            y1="5"
            x2="129.547"
            y2="254.796"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EEE1E0" />
            <Stop offset="1" stopColor="#C6BAB9" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_8631_22739"
            x1="129.656"
            y1="179.193"
            x2="129.656"
            y2="184.156"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#4665B6" />
            <Stop offset="1" stopColor="#7891D3" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_8631_22739"
            x1="123.5"
            y1="178"
            x2="123.5"
            y2="180"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#AC70DC" />
            <Stop offset="1" stopColor="#5C3C76" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_8631_22739"
            x1="52.8039"
            y1="129.338"
            x2="201.883"
            y2="127.888"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#EAD8FC" />
            <Stop offset="1" stopColor="#AE89D3" />
          </LinearGradient>
          <RadialGradient
            id="paint6_radial_8631_22739"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(168.78 138.761) rotate(180) scale(16.5509 18.4771)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#B57FE8" />
          </RadialGradient>
          <RadialGradient
            id="paint7_radial_8631_22739"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(116.832 112.183) rotate(-180) scale(18.8463 17.7194)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#7F9EF8" />
          </RadialGradient>
          <RadialGradient
            id="paint8_radial_8631_22739"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(113 108.5) rotate(56.3099) scale(7.2111 7.8049)">
            <Stop stopColor="white" />
            <Stop offset="1" stopColor="#B57FE8" />
          </RadialGradient>
          <LinearGradient
            id="paint9_linear_8631_22739"
            x1="129.847"
            y1="69.6288"
            x2="129.847"
            y2="74.9444"
            gradientUnits="userSpaceOnUse">
            <Stop stopColor="#4665B6" />
            <Stop offset="1" stopColor="#7891D3" />
          </LinearGradient>
        </Defs>
      </G>
    </AccessibleSvg>
  )
}

export const FirstArtLessonBookingUnlockedDetailed = styled(
  FirstArtLessonBookingUnlockedDetailedSvg
).attrs(({ size, theme }) => ({
  size: size ?? theme.illustrations.sizes.fullPage,
}))``
